<template>
    <modal-generic
    :title="t('approvals.operators.create.duplicateAccountInfoModal.title')"
    :showFooter="selectedAccounts.length"
    :buttonsFooterData="buttonsFooterData"
    :triggerClose="triggerClose"
    @hideMe="emit('hideMe')">
        <text-block-generic :params="{ content: t('approvals.operators.create.duplicateAccountInfoModal.note', { accountNumber: toDuplicateAccount }) }"/>
        <!-- Accounts Checkbox Group -->
        <selector-checkbox-group
        style="margin-top: 24px;"
        :checkboxParams="accountsAvailableToCheck"
        @clicked="checkboxClickHandler"/>
    </modal-generic>
</template>

<script setup>
import ModalGeneric from '@/components/generic/modals/side/Generic'
import TextBlockGeneric from '@/components/generic/textBlocks/Generic'
import SelectorCheckboxGroup from '@/components/generic/selectors/checkbox/CheckboxGroup'
/* Vue */
import { ref, computed } from 'vue'
import { accountFormatHelper } from '@/assets/scripts/strings'

/* Store */
import { mapGetters } from '@/store/helpers/mappers'
import { moduleMapper } from '@/store/helpers/modules.map'

/* i18n */
import { useI18n } from 'vue-i18n'
const { t } = useI18n()

/* mapActions & mapGetters */
const { getAccounts } = mapGetters(moduleMapper.APPROVALS_OPERATORS)

/* Emmitters */
const emit = defineEmits(['hideMe', 'duplicateInfoToAccounts'])

const props = defineProps({
    accounts: Array,
    accountToCopyIndex: Number
})

const selectedAccounts = ref([])
const triggerClose = ref(false)

const toDuplicateAccount = computed(() => {
    const account = props.accounts[props.accountToCopyIndex]
    const accountFormated = accountFormatHelper(account.accountNumber)
    return account.description === account.accountNumber ? accountFormated : `${account.description} - ${accountFormated}`
})

const accountsAvailableToCheck = computed(() => {
    return getAccounts.value.bankAccountView.reduce((acc, account) => {
        if (props.accounts.find(obj => obj.id === account.id)) return acc

        const accountFormated = accountFormatHelper(account.accountNumber)

        acc.push({
            id: account.id,
            label: account.description === account.accountNumber ? accountFormated : `${account.description} - ${accountFormated}`,
            selected: selectedAccounts.value.find(id => id === account.id)
        })
        return acc
    }, [])
})

const checkboxClickHandler = $event => {
    if (selectedAccounts.value.find(id => id === $event)) selectedAccounts.value = selectedAccounts.value.filter(id => id !== $event)
    else selectedAccounts.value.push($event)
}

const buttonsFooterData = [{
    label: t('approvals.operators.create.duplicateAccountInfoModal.clear'),
    icon: 'close',
    buttonPosition: 'left',
    callbackFunction: () => { selectedAccounts.value = [] }
}, {
    label: t('approvals.operators.create.duplicateAccountInfoModal.copyInfo'),
    icon: 'check-line',
    iconPosition: 'right',
    buttonType: 'primary',
    callbackFunction: () => {
        emit('duplicateInfoToAccounts', selectedAccounts.value)
        triggerClose.value = true
    }
}]
</script>

<style lang="scss" scoped>
</style>
